import { rawBaseQuery } from "../features/api/Api";
import badRequestHandler from "./badRequestHandler";
import createdHandler from "./createdHandler";
import forbiddenHandler from "./forbiddenHandler";
import notFoundHandler from "./notFoundHandler";
import serverErrorHandler from "./serverErrorHandler";
import unAuthorizedHandler from "./unAuthorizedHandler";

async function responseHandler(args: any, api: any, extraOptions: any) {
  let result: any = await rawBaseQuery(args, api, extraOptions);

  switch (result.meta.response?.status) {
    case 201:
      createdHandler();
      break;
    case 400:
      // badRequestHandler();
      break;
    case 401:
      result = await unAuthorizedHandler(args, api, extraOptions, result);
      break;
    case 403:
      forbiddenHandler(args, api);
      break;
    case 404:
      // notFoundHandler();
      break;
    case 500:
      // serverErrorHandler();
      break;
    default:
      break;
  }

  return result;
}

export default responseHandler;
